import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BasicRouting from './routing/routing.basicRouting';

function App() {
  return (
    <div className="App">
      <BasicRouting />
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        theme="dark"
        toastStyle={{ background: "#0f2040", border: "1px solid rgba(26,122,74,0.3)" }}
      />
    </div>
  );
}

export default App;
